import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { buildAppShellBreadcrumbs } from '@/layouts/core/buildAppShellBreadcrumbs';

export type { AppShellBreadcrumb } from '@/layouts/core/buildAppShellBreadcrumbs';

/**
 * Build breadcrumb trail from the current pathname.
 * @returns {import('@/layouts/core/buildAppShellBreadcrumbs').AppShellBreadcrumb[]}
 */
export function useAppShellBreadcrumbs() {
  const { pathname } = useLocation();

  return useMemo(() => buildAppShellBreadcrumbs(pathname), [pathname]);
}
